<template>
  <div class="smart field" :class="{'side-by-side':sideBySide}" :disabled="disabled">
    <div class="label-box">
      <slot name="label" :label="currentLabel">{{currentLabel}}:</slot>
    </div>
    <div class="input-box">
      <slot :value="value" :onChange="onChange" :onInput="onInput">
          <input class="smart input" :type="type" :value="value" @change="onChange" @input="onInput"/>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Smart-Field",
  props:{
      label: {
          type: String,
          default: null,
      },
      value: {
          default: null,
      },
      type: {
          type: String,
          default: "text",
      },
      labelDisabled: {
          type: String,
          default: null,
      },
      disabled:{
          type: Boolean,
          default: false,
      },
      sideBySide: {
          type: Boolean,
          default: true,
      },
  },
  computed:{
      currentLabel(){
          return (this.disabled && this.labelDisabled ? this.labelDisabled : this.label);
      }
  },
  methods:{
    onChange(value){
      this.$emit('change', value);
    },
    onInput(value){
      this.$emit('input', value);
    }
  }
};
</script>

<style>
.smart.field {
  display: flex;
  flex-direction: column;
}

.smart.field.side-by-side {
  flex-direction: row;
}

.smart.field > .label-box{
  align-self: flex-start;
  margin-bottom: 4px;
}

.smart.field.side-by-side > .label-box{
  align-self: center;
  margin-bottom: 0;
  margin-right: 4px;
}

.smart.field > .input-box{
  display: flex;
  flex: 1;
}

.smart.field > .input-box > *{
  flex: 1;
}
</style>

